import useCommonCollectionQuery from "@repo/shopifyV2/queries/useCollectionQuery";
import type { IUseCollectionQuery } from "@repo/shopifyV2/types/queries";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useCollection(
  params?: Pick<IUseCollectionQuery, "skipCollectionList" | "skipFilters" | "initialCollectionVariables">,
) {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonCollectionQuery({
    ...params,
    lang,
    openToast,
  });
}
